import { graphql } from "~/gql";

export const FIND_MATTER_COMPLETION_LOGS = graphql(/* GraphQL */ `
  query FindMatterCompletionLogs($matterId: Float!) {
    findMatterCompletionLogs(matterId: $matterId) {
      id
      matterId
      completionPercentage
      createdAt
    }
  }
`);
